import ActivityTypes from './ActivityTypes';

export default ActivityTypes;
